import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    '& > *': {
      margin: theme.spacing(2),
    },
  },
  loaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  warning: {
    color: 'red',
    display: 'block',
    width: '100%',
    textAlign: 'center',
  },
});
